import axios from "axios"
import store from "../store/index.js";
import { ElLoading } from 'element-plus'
import { reportWebError } from './webErrorLogger'

let LoadingObj = null;
let LoadingCount = 0;
let redirectingToLogin = false;

const handleUnauthorized = () => {
  localStorage.removeItem("userInfo")
  localStorage.removeItem("userLists")
  localStorage.removeItem("priorityLists")
  sessionStorage.removeItem("silent_token")
  try {
    store.commit("userInfo/setUserInfo", null)
  } catch (e) {
    // store 尚未完成初始化时，本地登录态清理仍然有效。
  }

  if (redirectingToLogin || window.location.hash.startsWith("#/login")) return
  redirectingToLogin = true
  window.location.replace(`${window.location.href.split("#")[0]}#/login`)
}

const openLoading = config => {
  if (config.silent) return
  config.__rdWithLoading = true
  LoadingCount += 1
  if (!LoadingObj) {
    LoadingObj = ElLoading.service({
      lock: true,
      text: "加载中",
      background: 'rgb(56, 86, 139)'
    })
  }
}

const closeLoading = config => {
  if (!config || !config.__rdWithLoading) return
  LoadingCount = Math.max(0, LoadingCount - 1)
  if (LoadingCount === 0 && LoadingObj) {
    LoadingObj.close()
    LoadingObj = null
  }
}

//使用create创建axios
const Service = axios.create({
  timeout: 8000,
  baseURL: "/api",
  headers: {
    "Content-Type": "application/json;chartset=utf-8"
  }
})
//请求拦截(拦截器)
Service.interceptors.request.use(config => {
  // 每次请求动态携带当前登录 token：登录/扫码成功后无需刷新页面即可生效
  // 静默登录过渡：URL 带来的 token 优先（避免用旧登录态换取错误用户）
  let token = sessionStorage.getItem("silent_token") || ""
  if (!token) {
    try {
      token = (store.state.userInfo && store.state.userInfo.userInfo && store.state.userInfo.userInfo.token) || ""
    } catch (e) {
      // 未初始化 store 时继续尝试 localStorage 中的 token。
    }
  }
  if (!token) {
    try {
      const ui = JSON.parse(localStorage.getItem("userInfo") || "null")
      token = (ui && ui.token) || ""
    } catch (e) {
      // 本地缓存损坏时按未登录处理。
    }
  }
  if (token) config.headers.Authorization = token
  openLoading(config)
  return config;
})
//响应拦截 对返回值做统一处理（响应拦截器）
Service.interceptors.response.use(response => {
  closeLoading(response.config)
  const res = response.data
  if (res && Number(res.code) === 401) {
    handleUnauthorized()
    return Promise.reject(new Error(res.msg || "登录状态已失效"))
  }
  if (res.code !== 200) {
    reportWebError({
      source: "API",
      message: res.msg || "服务器返回错误",
      detail: `响应代码: ${res.code}`,
      url: response.config && response.config.url,
      method: response.config && response.config.method,
      status: response.status
    })
    // 需要读取失败原因（含 msg）的调用方（如文件导入）可传 config.rawFail，此时返回完整 fail 响应
    return response.config && response.config.rawFail ? res : res.data;
  }
  return res.data;
}, error => {
  closeLoading(error.config)
  if (error && error.code === "ERR_CANCELED") return Promise.reject(error)
  if (error && error.response && Number(error.response.status) === 401) {
    handleUnauthorized()
  }
  reportWebError({
    source: "API",
    message: error.message || "服务器请求失败",
    detail: error.stack || "",
    url: error.config && error.config.url,
    method: error.config && error.config.method,
    status: error.response && error.response.status
  })
  return Promise.reject(error)
})
//post请求
export const post = config => {
  return Service({
    ...config,
    method: "post",
    data: config.data
  })
}
//get请求
export const get = config => {
  return Service({
    ...config,
    method: "get",
    params: config.data
  })
}
//put请求 更新
export const put = config => {
  return Service({
    ...config,
    method: "put",
    params: config.data
  })
}
//delete请求 更新
export const reqDelete = config => {
  return Service({
    ...config,
    method: "delete"
  })
}
